module.exports = __webpack_public_path__ + "static/flags/SZ-58a883ded529eb6a738deb949f2ba825.gif";